import { Component, OnInit, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { OnboardingInitService } from "./core/services/onboarding-init.service";
import { ConfirmationModalComponent } from "./shared/confirmation-modal/confirmation-modal.component";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [RouterOutlet, ConfirmationModalComponent],
  templateUrl: "./app.html",
  styleUrl: "./app.css",
})
export class App implements OnInit {
  private onboardingInitService = inject(OnboardingInitService);

  ngOnInit() {
    // Aguardar um pouco para garantir que os cookies estejam disponíveis
    setTimeout(() => {
      this.onboardingInitService.initializeOnboarding();
    }, 100);
  }
}
